<template>
  <div>
    <loading :active="loading"></loading>
    <main-layout :active="6">
      <div class="col-xl-12">
        <div class="row mb-4">
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
            <div class="card text-center pt-2" style="border-left: 4px solid #22C55E;">
              <div class="card-body">
                <p class="mb-1">Campanhas Ativas</p>
                <h4 style="color: #22C55E;">{{ activeCampaigns }}</h4>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6">
            <div class="card text-center pt-2" style="border-left: 4px solid #4F46E5;">
              <div class="card-body">
                <p class="mb-1">Total Participantes</p>
                <h4 style="color: #4F46E5;">{{ totalParticipants }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0">🎯 Campanhas de Consistência</h4>
            <button class="btn btn-primary" @click="showCreateModal = true">
              + Nova Campanha
            </button>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-striped mb-0">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>NOME</th>
                    <th>STATUS</th>
                    <th>NÍVEIS</th>
                    <th>AÇÕES</th>
                    <th>PARTICIPANTES</th>
                    <th>AÇÕES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="campaigns.length <= 0">
                    <td colspan="7" class="text-center py-4">
                      <span style="color: #9CA3AF;">Nenhuma campanha cadastrada</span>
                    </td>
                  </tr>
                  <tr v-for="item in campaigns" :key="item.id">
                    <td>#{{ item.id }}</td>
                    <td><strong>{{ item.name }}</strong></td>
                    <td>
                      <span :class="item.is_active ? 'badge bg-success' : 'badge bg-secondary'">
                        {{ item.is_active ? 'Ativa' : 'Pausada' }}
                      </span>
                    </td>
                    <td>{{ item.levels_count }}</td>
                    <td>{{ item.actions_count }}</td>
                    <td>{{ item.participants_count }}</td>
                    <td>
                      <div class="btn-group">
                        <button class="btn btn-info btn-sm" @click="viewCampaign(item)" title="Gerenciar">
                          ⚙️
                        </button>
                        <button class="btn btn-warning btn-sm" @click="toggleActive(item)"
                          :title="item.is_active ? 'Pausar' : 'Ativar'">
                          {{ item.is_active ? '⏸️' : '▶️' }}
                        </button>
                        <button class="btn btn-danger btn-sm" @click="deleteCampaign(item.id)" title="Deletar">
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Criar Campanha -->
      <div v-if="showCreateModal" class="modal-overlay" @click.self="showCreateModal = false">
        <div class="modal-content">
          <h5>➕ Nova Campanha</h5>
          <form @submit.prevent="createCampaign">
            <div class="mb-3">
              <label class="form-label">Nome da Campanha</label>
              <input type="text" class="form-control" v-model="newCampaign.name" required>
            </div>
            <div class="mb-3">
              <label class="form-label">Descrição</label>
              <textarea class="form-control" v-model="newCampaign.description" rows="2"></textarea>
            </div>
            <div class="d-flex gap-2 justify-content-end">
              <button type="button" class="btn btn-secondary" @click="showCreateModal = false">Cancelar</button>
              <button type="submit" class="btn btn-primary">Criar Campanha</button>
            </div>
          </form>
        </div>
      </div>

      <!-- Modal Ver Campanha -->
      <div v-if="selectedCampaign" class="modal-overlay" @click.self="selectedCampaign = null">
        <div class="modal-content modal-large">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h5 class="mb-0">⚙️ {{ selectedCampaign.name }}</h5>
            <button class="btn btn-close" @click="selectedCampaign = null"></button>
          </div>

          <!-- Tabs -->
          <ul class="nav nav-tabs mb-3">
            <li class="nav-item">
              <a class="nav-link" :class="{ active: detailTab === 'levels' }" @click="detailTab = 'levels'" href="#">
                🏆 Níveis ({{ selectedCampaign.levels ? selectedCampaign.levels.length : 0 }})
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: detailTab === 'actions' }" @click="detailTab = 'actions'" href="#">
                ⭐ Ações ({{ selectedCampaign.actions ? selectedCampaign.actions.length : 0 }})
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: detailTab === 'participants' }"
                @click="detailTab = 'participants'; loadParticipants()" href="#">
                👥 Participantes
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: detailTab === 'settings' }" @click="detailTab = 'settings'"
                href="#">
                ⚙️ Configurações Diárias
              </a>
            </li>
          </ul>

          <!-- Tab: Níveis -->
          <div v-if="detailTab === 'levels'">
            <div class="mb-3">
              <div class="input-group">
                <input type="number" class="form-control" v-model.number="newLevel.level_number" placeholder="Nível"
                  style="max-width: 80px;">
                <input type="number" class="form-control" v-model.number="newLevel.points_required"
                  placeholder="Pontos necessários">
                <input type="number" class="form-control" v-model.number="newLevel.reward_amount"
                  placeholder="Recompensa R$" step="0.01">
                <button class="btn btn-success" @click="addLevel">+ Adicionar</button>
              </div>
            </div>
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Nível</th>
                  <th>Pontos</th>
                  <th>Recompensa</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="level in selectedCampaign.levels" :key="level.id">
                  <td>Nível {{ level.level_number }}</td>
                  <td>{{ level.points_required }} pts</td>
                  <td><strong style="color: #22C55E;">R$ {{ parseFloat(level.reward_amount).toFixed(2) }}</strong></td>
                  <td>
                    <button class="btn btn-danger btn-sm" @click="removeLevel(level.id)">×</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Tab: Ações -->
          <div v-if="detailTab === 'actions'">
            <div class="mb-3">
              <div class="row g-2">
                <div class="col-2">
                  <input type="text" class="form-control" v-model="newAction.icon" placeholder="📱" maxlength="3">
                </div>
                <div class="col-3">
                  <input type="text" class="form-control" v-model="newAction.action_key" placeholder="action_key">
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" v-model="newAction.action_label" placeholder="Descrição">
                </div>
                <div class="col-1">
                  <input type="number" class="form-control" v-model.number="newAction.points" placeholder="Pts">
                </div>
                <div class="col-2">
                  <button class="btn btn-success w-100" @click="addAction">+ Add</button>
                </div>
              </div>
            </div>
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>Ícone</th>
                  <th>Chave</th>
                  <th>Descrição</th>
                  <th>Pontos</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="action in selectedCampaign.actions" :key="action.id">
                  <td>{{ action.icon }}</td>
                  <td><code>{{ action.action_key }}</code></td>
                  <td>{{ action.action_label }}</td>
                  <td>{{ action.points }} pts</td>
                  <td>
                    <button class="btn btn-danger btn-sm" @click="removeAction(action.id)">×</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Tab: Configurações Diárias -->
          <div v-if="detailTab === 'settings'">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Valor Mínimo (R$)</label>
                <input type="number" class="form-control" v-model.number="selectedCampaign.daily_reward_min"
                  step="0.01">
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">Valor Máximo (R$)</label>
                <input type="number" class="form-control" v-model.number="selectedCampaign.daily_reward_max"
                  step="0.01">
              </div>
            </div>

            <div class="mb-4">
              <label class="form-label">Missões Obrigatórias para Bônus</label>
              <div class="card p-3 bg-light">
                <div v-for="action in selectedCampaign.actions" :key="action.id" class="form-check mb-2">
                  <input class="form-check-input" type="checkbox" :id="'action-' + action.id" :value="action.action_key"
                    v-model="dailyRewardActions">
                  <label class="form-check-label" :for="'action-' + action.id">
                    {{ action.icon }} {{ action.action_label }} (<code>{{ action.action_key }}</code>)
                  </label>
                </div>
                <div v-if="!selectedCampaign.actions || selectedCampaign.actions.length === 0" class="text-muted">
                  Nenhuma ação cadastrada para esta campanha.
                </div>
              </div>
              <small class="text-muted">O usuário precisará completar todas as missões marcadas acima para poder
                resgatar o prêmio diário.</small>
            </div>

            <div class="d-flex justify-content-end">
              <button class="btn btn-primary" @click="saveDailySettings">
                Salvar Configurações
              </button>
            </div>
          </div>
        </div>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from "../../components/Layouts/MainLayout.vue";
import api from "../../services/funcoes-service";
import Loading from "../../components/Layouts/Loading.vue";

export default {
  components: { MainLayout, Loading },
  data() {
    return {
      campaigns: [],
      loading: true,
      activeCampaigns: 0,
      totalParticipants: 0,
      showCreateModal: false,
      newCampaign: { name: '', description: '' },
      selectedCampaign: null,
      detailTab: 'levels',
      participants: [],
      newLevel: { level_number: 1, points_required: 500, reward_amount: 10 },
      newAction: { icon: '✔️', action_key: '', action_label: '', points: 10 },
      dailyRewardActions: []
    };
  },
  async mounted() {
    await this.loadCampaigns();
  },
  methods: {
    async loadCampaigns() {
      try {
        this.loading = true;
        const res = await api.get('/campaigns');
        if (res.data.error === 0) {
          this.campaigns = res.data.campaigns;
          this.activeCampaigns = this.campaigns.filter(c => c.is_active).length;
          this.totalParticipants = this.campaigns.reduce((sum, c) => sum + (c.participants_count || 0), 0);
        }
      } catch (error) {
        this.$toast.error('Erro ao carregar campanhas');
      } finally {
        this.loading = false;
      }
    },

    async createCampaign() {
      try {
        await api.post('/campaigns', this.newCampaign);
        this.$toast.success('Campanha criada!');
        this.showCreateModal = false;
        this.newCampaign = { name: '', description: '' };
        await this.loadCampaigns();
      } catch (error) {
        this.$toast.error('Erro ao criar campanha');
      }
    },

    async viewCampaign(item) {
      try {
        const res = await api.get(`/campaigns/${item.id}`);
        this.selectedCampaign = res.data.campaign;
        this.detailTab = 'levels';

        // Carrega ações obrigatórias se existirem
        if (this.selectedCampaign.daily_reward_required_actions) {
          try {
            this.dailyRewardActions = JSON.parse(this.selectedCampaign.daily_reward_required_actions);
          } catch (e) {
            this.dailyRewardActions = [];
          }
        } else {
          this.dailyRewardActions = [];
        }
      } catch (error) {
        this.$toast.error('Erro ao carregar campanha');
      }
    },

    async toggleActive(item) {
      try {
        await api.put(`/campaigns/${item.id}`, { is_active: !item.is_active });
        this.$toast.success(item.is_active ? 'Campanha pausada' : 'Campanha ativada');
        await this.loadCampaigns();
      } catch (error) {
        this.$toast.error('Erro ao atualizar campanha');
      }
    },

    async deleteCampaign(id) {
      if (!confirm('Tem certeza que deseja deletar esta campanha?')) return;
      try {
        await api.delete(`/campaigns/${id}`);
        this.$toast.success('Campanha deletada');
        await this.loadCampaigns();
      } catch (error) {
        this.$toast.error('Erro ao deletar campanha');
      }
    },

    async addLevel() {
      try {
        await api.post(`/campaigns/${this.selectedCampaign.id}/levels`, this.newLevel);
        this.$toast.success('Nível adicionado!');
        await this.viewCampaign(this.selectedCampaign);
      } catch (error) {
        this.$toast.error('Erro ao adicionar nível');
      }
    },

    async removeLevel(id) {
      try {
        await api.delete(`/campaigns/levels/${id}`);
        this.$toast.success('Nível removido');
        await this.viewCampaign(this.selectedCampaign);
      } catch (error) {
        this.$toast.error('Erro ao remover nível');
      }
    },

    async addAction() {
      try {
        await api.post(`/campaigns/${this.selectedCampaign.id}/actions`, this.newAction);
        this.$toast.success('Ação adicionada!');
        this.newAction = { icon: '✔️', action_key: '', action_label: '', points: 10 };
        await this.viewCampaign(this.selectedCampaign);
      } catch (error) {
        this.$toast.error('Erro ao adicionar ação');
      }
    },

    async removeAction(id) {
      try {
        await api.delete(`/campaigns/actions/${id}`);
        this.$toast.success('Ação removida');
        await this.viewCampaign(this.selectedCampaign);
      } catch (error) {
        this.$toast.error('Erro ao remover ação');
      }
    },

    async loadParticipants() {
      try {
        const res = await api.get(`/campaigns/${this.selectedCampaign.id}/participants`);
        this.participants = res.data.participants || [];
      } catch (error) {
        this.$toast.error('Erro ao carregar participantes');
      }
    },

    async saveDailySettings() {
      try {
        const payload = {
          daily_reward_min: this.selectedCampaign.daily_reward_min,
          daily_reward_max: this.selectedCampaign.daily_reward_max,
          daily_reward_required_actions: this.dailyRewardActions
        };
        await api.put(`/campaigns/${this.selectedCampaign.id}`, payload);
        this.$toast.success('Configurações salvas!');
      } catch (error) {
        this.$toast.error('Erro ao salvar configurações');
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 24px;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
}

.modal-large {
  max-width: 800px;
  max-height: 80vh;
  overflow-y: auto;
}

.badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
}

.nav-tabs .nav-link {
  cursor: pointer;
}

.gap-2 {
  gap: 8px;
}
</style>
